import { createSlice } from "@reduxjs/toolkit";

export const MembershipSlice = createSlice({
  name: "Membership",
  initialState: {
    MembershipLoading: false,
    MembershipPlans: [],
  },
  reducers: {
    getMembershipPlans: (state) => {
      state.MembershipLoading = true;
    },
    setMembershipPlans: (state, action) => {
      state.MembershipPlans = action.payload;
      state.MembershipLoading = false;
    },
  },
});

export const { getMembershipPlans, setMembershipPlans } =
  MembershipSlice.actions;

export default MembershipSlice.reducer;
